export { default, type CardMomentProps } from './card-moment'
